export enum TaskOptions {
    STATUSES = 'statuses',
    SEVERITIES = 'severities',
    CATEGORIES = 'categories',
    SUBCATEGORIES = 'subCategories',
    INTAKE_METHODS = 'intakeMethods',
    REQUIREMENT_SOURCES = 'requirementSources',
    ERRORS = 'errors',
}

export const categoryNamePlaceholder = 'Unassigned'

export const tabsWithChildElements = [TaskOptions.SUBCATEGORIES, TaskOptions.ERRORS]
